import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PurchaseOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_create_purchase_order_line_in_processing_status_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { projectId: number, orderId: number, shipmentId: number, materialId: number, packagingId: number, packagedAmount: number, lotId?: number, vendorLotId?: number, grossWeight?: number, weightUom?: number, notes?: string, netWeight?: number }): Promise<{ lineNumber?: number, reason?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.projectId)) {
      $missingRequiredInParams.push('\'projectId\'');
    }
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.shipmentId)) {
      $missingRequiredInParams.push('\'shipmentId\'');
    }
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil($inParams.packagingId)) {
      $missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil($inParams.packagedAmount)) {
      $missingRequiredInParams.push('\'packagedAmount\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

